module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_08-56a55374de195d8768ba519654e327b5.jpg";